import { render } from "./NewProjectDialog.vue?vue&type=template&id=e0dcfbf6&scoped=true"
import script from "./NewProjectDialog.vue?vue&type=script&lang=js"
export * from "./NewProjectDialog.vue?vue&type=script&lang=js"

import "./NewProjectDialog.vue?vue&type=style&index=0&id=e0dcfbf6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0dcfbf6"]])

export default __exports__